export default "__VITE_ASSET__Cmqgrv3S__"